import React from "react";
import {defterUnitName} from "../helper/permission";
import {EntegratorConf} from "./index";

export const outboxContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Zarf UUID',	accessor: 'getEnvelopeUuid', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Fatura Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Fatura Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen URN', accessor: 'getSourceUrn', type: 'String'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı URN',	accessor: 'getDestinationUrn', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Fatura Türü', accessor: 'getInvoiceTypeCode', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'},
	{name: 'Fatura Durumu', accessor: 'getProcessState', type: 'String'},
	{name: 'Cevap Durumu', accessor: 'getResponseValidationState', type: 'String'},
	{name: 'Fatura Toplamı', accessor: 'getInvoiceTotal', type: 'Currency'},
	{name: 'Mal Hizmet Tutarı', accessor: 'getLineExtensionAmount', type: 'Currency'},
	{name: 'Vergiler Hariç Tutar', accessor: 'getTaxExclusiveAmount', type: 'Currency'},
	{name: 'Vergiler Dahil Tutar', accessor: 'getTaxInclusiveAmount', type: 'Currency'},
	{name: 'İskonto Tutarı', accessor: 'getAllowanceTotalAmount', type: 'Currency'}
];

export const outboxStatusContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Zarf UUID',	accessor: 'getEnvelopeUuid', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Fatura Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Fatura Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen URN', accessor: 'getSourceUrn', type: 'String'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı URN',	accessor: 'getDestinationUrn', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Fatura Türü', accessor: 'getInvoiceTypeCode', type: 'String'},
	{name: 'Durum Kodu', accessor: 'getProcessState', type: 'Integer'},
	{name: 'Durumu', accessor: 'getProcessResult', type: 'Integer'},
	{name: 'Durum Açıklaması', accessor: 'getResultExplanation', type: 'String'}
];

export const inboxContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Zarf UUID',	accessor: 'getEnvelopeUuid', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Fatura Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Fatura Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen URN', accessor: 'getSourceUrn', type: 'String'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı URN',	accessor: 'getDestinationUrn', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Fatura Türü', accessor: 'getInvoiceTypeCode', type: 'String'},
	{name: 'Cevap Durumu', accessor: 'getResponseValidationState', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'},
	{name: 'Fatura Toplamı', accessor: 'getInvoiceTotal', type: 'Currency'},
	{name: 'Mal Hizmet Tutarı', accessor: 'getLineExtensionAmount', type: 'Currency'},
	{name: 'Vergiler Hariç Tutar', accessor: 'getTaxExclusiveAmount', type: 'Currency'},
	{name: 'Vergiler Dahil Tutar', accessor: 'getTaxInclusiveAmount', type: 'Currency'},
	{name: 'İskonto Tutarı', accessor: 'getAllowanceTotalAmount', type: 'Currency'}
];

export const eDespatchOutboxContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'İrsaliye No', accessor: 'getDocumentId', type: 'String'},
	{name: 'Zarf UUID',	accessor: 'getEnvelopeUuid', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'İrsaliye Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen URN', accessor: 'getSourceUrn', type: 'String'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı URN',	accessor: 'getDestinationUrn', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'İrsaliye Türü', accessor: 'getDespatchTypeCode', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'},
	{name: 'İrsaliye Toplamı', accessor: 'getDespatchTotal', type: 'Currency'},
];

export const eDespatchOutboxStatusContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'İrsaliye No', accessor: 'getDocumentId', type: 'String'},
	{name: 'Zarf UUID',	accessor: 'getEnvelopeUuid', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'İrsaliye Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen URN', accessor: 'getSourceUrn', type: 'String'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı URN',	accessor: 'getDestinationUrn', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'İrsaliye Türü', accessor: 'getDespatchTypeCode', type: 'String'},
	{name: 'Durum Kodu', accessor: 'getProcessState', type: 'Integer'},
	{name: 'Durumu', accessor: 'getProcessResult', type: 'Integer'},
	{name: 'Durum Açıklaması', accessor: 'getResultExplanation', type: 'String'}

]

export const despatchOutboxTransferContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'İrsaliye No', accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'İrsaliye Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'İrsaliye Türü', accessor: 'getDespatchTypeCode', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'}
];

export const eDespatchInboxContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'İrsaliye No', accessor: 'getDocumentId', type: 'String'},
	{name: 'Zarf UUID',	accessor: 'getEnvelopeUuid', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'İrsaliye Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen URN', accessor: 'getSourceUrn', type: 'String'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı URN',	accessor: 'getDestinationUrn', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'İrsaliye Türü', accessor: 'getDespatchTypeCode', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'},
	{name: 'İrsaliye Toplamı', accessor: 'getDespatchTotal', type: 'Currency'},
];

export const despatchInboxTransferContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'İrsaliye No', accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'İrsaliye Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'İrsaliye Türü', accessor: 'getDespatchTypeCode', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'}
];

export const eArchiveContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Rapor UUID',	accessor: 'getRaporUuid', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Fatura Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Fatura Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Fatura Türü', accessor: 'getInvoiceTypeCode', type: 'String'},
	{name: 'Fatura Durumu', accessor: 'getProcessState', type: 'String'},
	{name: 'İptal Durumu', accessor: 'getCancelled', type: 'String'},
	{name: 'İptal Tarihi', accessor: 'getCancelDate', type: 'Date'},
	{name: 'İptal Sebebi', accessor: 'getCancelReason', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'},
	{name: 'Fatura Toplamı', accessor: 'getInvoiceTotal', type: 'Currency'},
	{name: 'Mal Hizmet Tutarı', accessor: 'getLineExtensionAmount', type: 'Currency'},
	{name: 'Vergiler Dahil Tutar', accessor: 'getTaxInclusiveAmount', type: 'Currency'},
	{name: 'Vergiler Hariç Tutar', accessor: 'getTaxExclusiveAmount', type: 'Currency'},
	{name: 'İskonto Tutarı', accessor: 'getAllowanceTotalAmount', type: 'Currency'}
];

export const expenseNoteContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Pusula No', accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId', type: 'String'},
	{name: 'Alıcı', accessor: 'getDestinationId', type: 'String'},
	{name: 'Pusula Tarihi', accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Pusula Alınma Tarihi', accessor: 'getReceivedDate', type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Pusula Durumu', accessor: 'getProcessState', type: 'String'},
	{name: 'İptal Durumu', accessor: 'getCancelled', type: 'String'},
	{name: 'İptal Tarihi', accessor: 'getCancelDate', type: 'Date'},
	{name: 'İptal Sebebi', accessor: 'getCancelReason', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'},
	{name: 'Pusula Toplamı', accessor: 'getDocumentTotal', type: 'Currency'},
	{name: 'Mal Hizmet Tutarı', accessor: 'getLineExtensionAmount', type: 'Currency'},
	{name: 'Vergiler Dahil Tutar', accessor: 'getTaxInclusiveAmount', type: 'Currency'},
	{name: 'Vergiler Hariç Tutar', accessor: 'getTaxExclusiveAmount', type: 'Currency'},
	{name: 'İskonto Tutarı', accessor: 'getAllowanceTotalAmount', type: 'Currency'}
];

export const expenseNoteStatusContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Pusula No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Pusula Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Pusula Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Pusula Türü', accessor: 'getInvoiceTypeCode', type: 'String'},
	{name: 'Durum Kodu', accessor: 'getProcessState', type: 'Integer'},
	{name: 'Durumu', accessor: 'getProcessResult', type: 'Integer'},
	{name: 'Durum Açıklaması', accessor: 'getResultExplanation', type: 'String'}

];

export const eArchiveStatusContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Fatura Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Fatura Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Fatura Türü', accessor: 'getInvoiceTypeCode', type: 'String'},
	{name: 'Durum Kodu', accessor: 'getProcessState', type: 'Integer'},
	{name: 'Durumu', accessor: 'getProcessResult', type: 'Integer'},
	{name: 'Durum Açıklaması', accessor: 'getResultExplanation', type: 'String'}

]

export const eArchiveTransferContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Fatura Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Fatura Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'},
	{name: 'Fatura Toplamı', accessor: 'getInvoiceTotal', type: 'Currency'},
];

export const eVoucherTransferContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Makbuz No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Makbuz Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Makbuz Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Senaryo Türü', accessor: 'getDocumentProfile', type: 'String'},
	{name: 'Para Birimi', accessor: 'getCurrencyCode', type: 'String'},
	{name: 'Makbuz Toplamı', accessor: 'getDocumentTotal', type: 'Currency'},
];

export const outboxTransferContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Fatura Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Fatura Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Fatura Toplamı', accessor: 'getInvoiceTotal', type: 'Currency'},
	{name: 'Mal Hizmet Tutarı', accessor: 'getLineExtensionAmount', type: 'Currency'},
	{name: 'Vergiler Hariç Tutar', accessor: 'getTaxExclusiveAmount', type: 'Currency'},
	{name: 'Vergiler Dahil Tutar', accessor: 'getTaxInclusiveAmount', type: 'Currency'},
	{name: 'İskonto Tutarı', accessor: 'getAllowanceTotalAmount', type: 'Currency'}
];

export const inboxTransferContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Fatura Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Fatura Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Fatura Toplamı', accessor: 'getInvoiceTotal', type: 'Currency'},
	{name: 'Mal Hizmet Tutarı', accessor: 'getLineExtensionAmount', type: 'Currency'},
	{name: 'Vergiler Hariç Tutar', accessor: 'getTaxExclusiveAmount', type: 'Currency'},
	{name: 'Vergiler Dahil Tutar', accessor: 'getTaxInclusiveAmount', type: 'Currency'},
	{name: 'İskonto Tutarı', accessor: 'getAllowanceTotalAmount', type: 'Currency'}
];

export const archiveVoucherContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Alıcı Kişi', accessor: 'getDestinationPname', type: 'String'},
	{name: 'Makbuz Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Makbuz Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Makbuz Toplamı', accessor: 'getDocumentTotal', type: 'Currency'},
	{name: 'Mal Hizmet Tutarı', accessor: 'getLineExtensionAmount', type: 'Currency'},
	{name: 'Vergiler Hariç Tutar', accessor: 'getTaxExclusiveAmount', type: 'Currency'},
	{name: 'Vergiler Dahil Tutar', accessor: 'getTaxInclusiveAmount', type: 'Currency'},
	{name: 'İskonto Tutarı', accessor: 'getAllowanceTotalAmount', type: 'Currency'}
];

export const archiveVoucherStatusContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Alıcı Kişi', accessor: 'getDestinationPname', type: 'String'},
	{name: 'Makbuz Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Makbuz Alınma Tarihi', accessor: 'getReceivedDate',	type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Durum Kodu', accessor: 'getProcessState', type: 'Integer'},
	{name: 'Durumu', accessor: 'getProcessResult', type: 'Integer'},
	{name: 'Durum Açıklaması', accessor: 'getResultExplanation', type: 'String'}
]

export const exchangeStatusContent = [
	{name: 'ETTN', accessor: 'getDocumentUuid', type: 'String'},
	{name: 'Döviz No',	accessor: 'getDocumentId', type: 'String'},
	{name: 'Gönderen', accessor: 'getSourceId',	type: 'String'},
	{name: 'Alıcı',	accessor: 'getDestinationId', type: 'String'},
	{name: 'Alıcı Kişi', accessor: 'getDestinationPname', type: 'String'},
	{name: 'Belge Türü', accessor: 'getDocumentType', type: 'String'},
	{name: 'Döviz Türü', accessor: 'getSourceCurrency', type: 'String'},
	{name: 'Döviz Tarihi',	accessor: 'getDocumentIssueDate', type: 'Date'},
	{name: 'Gönderen Unvanı', accessor: 'getSourceTitle', type: 'String'},
	{name: 'Alıcı Unvanı', accessor: 'getDestinationTitle', type: 'String'},
	{name: 'Durum Kodu', accessor: 'getProcessState', type: 'Integer'},
	{name: 'Durumu', accessor: 'getProcessResult', type: 'Integer'},
	{name: 'Durum Açıklaması', accessor: 'getResultExplanation', type: 'String'}
]

export const creditReportContent = [
	{name: 'VKN/TCKN', accessor: 'getVknTckn', type: 'String'},
	{name: 'Müşteri Adı',	accessor: 'getCustomer', type: 'String'},
	{name: 'Telefon Numarası',	accessor: 'getCustomer' , subAccessor: 'getSorumluCepTel', type: 'String'},
	{name: 'Birim Türü', accessor: 'getUnit',	type: 'String'},
	{name: 'İşlem Türü',	accessor: 'getActionType', type: 'String'},
	{name: 'Yüklenen Miktar', accessor: 'getLoaded', type: 'Integer'},
	{name: 'Harcanan Miktar',	accessor: 'getSpent', type: 'Integer'},
	{name: 'Müşteri Durumu',	accessor: 'getCustomer', type: 'Boolean'},
	{name: 'Sözleşme Bitiş Tarihi', accessor: 'getFinishDate',	type: 'Date'}
];

export const customerContent = [
	{name: 'VKN/TCKN', accessor: 'getVknTckn', type: 'String'},
	{name: 'Unvan',	accessor: 'getFormattedName', type: 'String'},
	{name: 'Ad', accessor: 'getGivenName',	type: 'String'},
	{name: 'Soyad', accessor: 'getFamilyName',	type: 'String'},
	{name: 'Kullanıcı Adı', accessor: 'getUsername',	type: 'String'},
	{name: 'Telefon', accessor: 'getPhone',	type: 'String'},
	{name: 'e-Posta', accessor: 'getEmail',	type: 'String'},
	{name: 'Müşteri Durumu', accessor: 'getActive',	type: 'String'},
	{name: 'Müşteri Türü', accessor: 'getMusteriTuru',	type: 'String'},
	{name: 'Şehir', accessor: 'getCity',	type: 'String'},
	{name: 'Kontörlü', accessor: 'getKontorlu',	type: 'String'},
	{name: 'Faturalı', accessor: 'getFaturali',	type: 'String'},
	{name: 'Yüklenen Kontör', accessor: 'getCreditLoaded',	type: 'Double'},
	{name: 'Harcanan Kontör', accessor: 'getCreditSpent',	type: 'Double'},
	{name: 'Kalan Kontör', accessor: 'getCreditRemain',	type: 'Double'},
	{name: 'Yüklenen '+defterUnitName(EntegratorConf.identifier), accessor: 'getMemoryLoaded',	type: 'Double'},
	{name: 'Harcanan '+defterUnitName(EntegratorConf.identifier), accessor: 'getMemorySpent',	type: 'Double'},
	{name: 'Kalan '+defterUnitName(EntegratorConf.identifier), accessor: 'getMemoryRemain',	type: 'Double'},
	{name: 'Kayıt Tarihi', accessor: 'getCreatedAt',	type: 'Date'},
	{name: 'eArşiv', accessor: 'geteArsiv',	type: 'String'},
	{name: 'eFatura', accessor: 'geteFatura',	type: 'String'},
	{name: 'eDefter', accessor: 'geteDefter',	type: 'String'},
	{name: 'Saklama', accessor: 'getSaklama',	type: 'String'},
	{name: 'eDefter Saklama', accessor: 'geteDefterYukleme',	type: 'String'},
	{name: 'eİrsaliye', accessor: 'geteIrsaliye',	type: 'String'},
	{name: 'S.M. Makbuzu', accessor: 'getSmm',	type: 'String'},
	{name: 'M. Makbuzu', accessor: 'getMm',	type: 'String'},
	{name: 'Eski OKC', accessor: 'getEskiOkc',	type: 'String'},
	{name: 'Yeni OKC', accessor: 'getYeniOkc',	type: 'String'},
	{name: 'Defter Kontrol', accessor: 'getDefterKontrol',	type: 'String'},
	{name: 'Ön Muhasebe', accessor: 'getOnMuhasebe',	type: 'String'},
	{name: 'Müşteri Temsilcisi', accessor: 'getMusteriTemsilcisi',	type: 'String'},
	{name: 'Bayi', accessor: 'getParentCustomerName',	type: 'String'},
	{name: 'Şehir', accessor: 'getCity', type: 'String'},
	{name: 'İlçe', accessor: 'getSubdivision', type: 'String'},
	{name: 'Vergi Dairesi', accessor: 'getTaxOffice', type: 'String'},
];

export const requestMessageContent = [
    {name: 'Müşteri Adı', accessor: 'getCustomer', type: 'String'},
    {name: 'Konu Tipi', accessor: 'getSubjectType',	type: 'String'},
    {name: 'Konu',	accessor: 'getSubject', type: 'String'},
    {name: 'Talep Durumu', accessor: 'getStatusMessage', type: 'String'},
    {name: 'Talep Tarihi',	accessor: 'getCreatedAt', type: 'Date'},
    {name: 'Cevap Tarihi', accessor: 'getAnswerAt',	type: 'Date'}
];

export const  progressPaymentContent =[
	{name: 'VKN/TCKN', accessor: 'getCustomer' , subAccessor: 'getVknTckn', type: 'String'},
	{name: 'Bayi', accessor: 'getCustomer',subAccessor:'getParentCustomerId', type: 'String'},
	{name: 'Ünvan', accessor: 'getCustomer', subAccessor:'getCustomerName', type: 'String'},
	{name: 'İşlem Türü', accessor: 'getCreditAction', type: 'String'},
	{name: 'Birim Türü', accessor: 'getUnit', type: 'String'},
	{name: 'Miktar', accessor: 'getCount', type: 'String'},
	{name: 'Alınma Zamanı', accessor: 'getPurchaseDate', type: 'Date'},
];

 export const  progressPaymentPaytrContent =[
	 {name: 'VKN/TCKN', accessor: 'getCustomer' , subAccessor: 'getVknTckn', type: 'String'},
	 {name: 'Ünvan', accessor: 'getCustomer', subAccessor:'getCustomerName', type: 'String'},
	 {name: 'İşlem Yeri', accessor: 'getHost', type: 'String'},
	 {name: 'Ödeme Yeri', accessor: 'getPaymentType', type: 'String'},
	 {name: 'Fiyat', accessor: 'getTotalPrice', type: 'String'},
	 {name: 'Fatura Numarası', accessor: 'getDocumentId', type: 'String'},
	 {name: 'Faturalandırma Durumu', accessor: 'getIsInvoiced', type: 'String'},
	 {name: 'Alınma Zamanı', accessor: 'getUpdatedAt', type: 'Date'},
	 {name: 'Alım Yapılan VKN/TCKN', accessor: 'getClientCustomer', subAccessor: "getVknTckn" , type: 'String'},
	 {name: 'Alım Yapılan Unvan', accessor: 'getClientCustomer', subAccessor: "getCustomerName" , type: 'String'}
 ];

 export const progressPaymentHakedisContent = [
	 {name: 'VKN/TCKN', accessor: 'getDistributor' , subAccessor: 'getVknTckn', type: 'String'},
	 {name: 'Ünvan', accessor: 'getDistributor', subAccessor:'getCustomerName', type: 'String'},
	 {name: "Başlangıç Tarihi", accessor: "getStartDate", type:'Date'},
	 {name: "Bitiş Tarihi", accessor: "getFinishDate", type: 'Date'},
	 {name: "Hakediş Oranı(Kontör)", accessor: "getCreditPercentage", type: 'BigDecimal'},
	 {name: "Hakediş Oranı("+defterUnitName(EntegratorConf.identifier)+")", accessor: "getStoragePercentage", type: 'BigDecimal'},
	 {name: "Kontör Adeti", accessor: "getTotalCreditPurchase", type: 'BigDecimal'},
	 {name: defterUnitName(EntegratorConf.identifier), accessor: "getTotalStoragePurchase", type: 'BigDecimal'},
	 {name: "Kontör Tutarı", accessor: "getTotalCreditAmount", type: 'BigDecimal'},
	 {name: defterUnitName(EntegratorConf.identifier)+" Tutarı", accessor: "getTotalStorageAmount", type: 'BigDecimal'},
	 {name: "Hakediş Tutarı", accessor: "getTotalAmount", type: 'BigDecimal'},
	 {name: "Aktif Müşteri Sayısı", accessor: "getActiveCustomerCount", type: 'Integer'},
	 {name: "Durum", accessor: "getState", type: 'String'},
	 {name: "Oluşturulma Zamanı", accessor: "getCreatedAt", type: 'Date'},
	 {name: "Güncelleme Zamanı", accessor: "getUpdatedAt", type: 'Date'},
 ];

 export const distributorContent =[
	 {name: 'VKN/TCKN', accessor: 'getVknTckn' , type: 'String'},
	 {name: 'Ad', accessor: 'getGivenName', type: 'String'},
	 {name: 'Soyad', accessor: 'getFamilyName', type: 'String'},
	 {name: 'Ünvan', accessor: 'getCustomerName', type: 'String'},
	 {name: 'Şehir', accessor: 'getCity', type: 'String'},
	 {name: 'Vergi Dairesi', accessor: 'getTaxOffice', type: 'String'},
	 {name: 'Kurumsal EPosta', accessor: 'getCorporateMail', type: 'String'},
	 {name: 'Mersis No', accessor: 'getMersisNo', type: 'String'},
	 {name: 'Ticaret Sicil No', accessor: 'getTicaretSicilNo', type: 'String'},
	 {name: "Bayi Çalışma Şekli", accessor: "getWorkType", type: 'String'},
	 {name: "Hakediş Oranı", accessor: "getHakedisOran", type: 'BigDecimal'},
	 {name: "Hakediş Tutarı", accessor: 'getTotalAmount', type: 'BigDecimal'},
	 {name: 'Oluşturulma Tarihi', accessor: 'getCreatedAt', type: 'Date'},
	 {name: 'Sorumlu TCKN', accessor: 'getSorumluTckn', type: 'String'},
	 {name: 'Sorumlu Adı', accessor: 'getSorumluAd', type: 'String'},
	 {name: 'Sorumlu Soyadı', accessor: 'getSorumluAd', type: 'String'},
	 {name: 'Sorumlu CepTel', accessor: 'getSorumluCepTel', type: 'String'},
	 {name: 'Sorumlu EPosta', accessor: 'getSorumluEPosta', type: 'String'},
	 {name: 'Aktif Müşteri', accessor: 'getIsActiveNum', type: 'String'},
	 {name: 'Pasif Müşteri', accessor: 'getIsPassiveNum', type: 'String'},
 ];

export const faultyOutboxDeniedContent = [
	{name: 'Gönderici VKN/TCKN', accessor: 'inbox' , subAccessor: 'getSourceId', type: 'String'},
	{name: 'Gönderici Ünvan', accessor: 'inbox' , subAccessor: 'getSourceTitle', type: 'String'},
	{name: 'Alım Tarihi',	accessor: 'inbox',  subAccessor: 'getReceivedDate', type: 'Date'},
	{name: 'ETTN',	accessor: 'inbox',  subAccessor: 'getDocumentUuid', type: 'String'},
	{name: 'Fatura No',	accessor: 'inbox',  subAccessor: 'getDocumentId', type: 'String'},
	{name: 'Alıcı VKN/TCKN', accessor: 'getSourceId', type: 'String'},
	{name: 'Alıcı Ünvan',	accessor: 'getSourceTitle', type: 'String'},
	{name: 'Cevaplama Tarihi', accessor: 'getDocumentIssueDate',	type: 'Date'},
	{name: 'İşlem Durumu', accessor: 'getProcessState',	type: 'Integer'},
	{name: 'İşlem Sonucu', accessor: 'getProcessResult',	type: 'Integer'},
	{name: 'Sonuç Açıklaması', accessor: 'getResultExplanation', type: 'String'},

];

export const smsToExcel = [
	{name: 'VKN/TCKN', accessor: 'getVknTckn' , type: 'String'},
	{name: 'Ünvan', accessor: 'getCustomerName', type: 'String'},
	{name: 'Sms Sayısı', accessor: 'getSmsNumber',	type: 'Long'},
];

export const sgkAppointmentContent =[
	{name: 'VKN/TCKN', accessor: 'getCustomer' , subAccessor: 'getVknTckn', type: 'String'},
	{name: 'Müşteri Adı', accessor: 'getCustomer',subAccessor:'getCustomerName', type: 'String'},
	{name: 'e-Posta', accessor: 'getEmail',	type: 'String'},
	{name: 'Telefon', accessor: 'getPhone',	type: 'String'},
	{name: 'Randevu Zamanı', accessor: 'getAppointmentTime', type: 'Date'},
	{name: "Oluşturulma Zamanı", accessor: "getCreatedAt", type: 'Date'},
	{name: "Güncelleme Zamanı", accessor: "getUpdatedAt", type: 'Date'},
	{name: "Randevu Durumu", accessor: "getStatusMessage", type: 'String'},
	{name: "Müşteri Açıklaması", accessor: "getNote", type: "String"}
];

export const eBelgeIn = [
	{name: 'VKN/TCKN', accessor: 'getVknTckn', type: 'String'},
	{name: 'Unvan', accessor: 'getTitle', type: 'String'},
	{name: 'Belge Tarihi', accessor: 'getIssueDate', type: 'Date'},
	{name: 'Belge No', accessor: 'getDocumentId', type: 'String'},
	{name: 'Tesisat No', accessor: 'getTesisatNo', type: 'String'},
	{name: 'Ödenecek Tutar', accessor: 'getTaxExclusiveAmount', type: 'Currency'},
	{name: 'Vergi Tutarı', accessor: 'getTotalKdv18Amount', type: 'Currency'},
	{name: 'Toplam Tutar', accessor: 'getPayableAmount', type: 'Currency'}
];